import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useRef, useState, } from 'react';
import { useDeepCompareEffect } from '../utils/useDeepCompareEffect';
export const RendererContext = createContext({
    dataSets: null,
    model: 'unknown',
    prefetchedData: { roles: [], companySizes: [] },
    setState: () => { },
    state: {},
    useStateByKey: () => [{}, () => { }],
});
export const useRendererContext = () => useContext(RendererContext);
export const useStateByKey = (key, initialState) => {
    const { state, setState } = useRendererContext();
    const hasSetInitialState = useRef(false);
    const setStateByKey = useCallback((newState) => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: Object.assign(Object.assign({}, prevState[key]), newState) })));
    }, [key, setState]);
    useDeepCompareEffect(() => {
        if (initialState) {
            hasSetInitialState.current = true;
            setStateByKey(Object.assign(Object.assign({}, initialState), { _intialState: initialState }));
        }
    }, [initialState, setStateByKey]);
    const stateByKey = state === null || state === void 0 ? void 0 : state[key];
    if (!hasSetInitialState.current && initialState)
        return [initialState, setStateByKey];
    return [stateByKey, setStateByKey];
};
export const withRendererContext = (Component) => (props) => {
    var _a, _b, _c, _d, _e, _f;
    // Data used by Google to display rich results in search - https://developers.google.com/search/docs/appearance/structured-data/intro-structured-data
    const [structuredData, setStructuredData] = useState('');
    const [state, setState] = useState({});
    useEffect(() => {
        if (!structuredData)
            return;
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.innerHTML = structuredData;
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, [structuredData]);
    return (_jsx(RendererContext.Provider, Object.assign({ value: {
            contentID: (_a = props.content) === null || _a === void 0 ? void 0 : _a.id,
            model: (_b = props.content) === null || _b === void 0 ? void 0 : _b.model,
            dataSets: ((_c = props.content) === null || _c === void 0 ? void 0 : _c.dataSets) || null,
            name: (_d = props.content) === null || _d === void 0 ? void 0 : _d.name,
            prefetchedData: Object.assign({}, (((_e = props.content) === null || _e === void 0 ? void 0 : _e.prefetchedData) || {
                roles: [],
                companySizes: [],
            })),
            serviceName: props.serviceName,
            setStructuredData,
            structuredData,
            variations: (_f = props.content) === null || _f === void 0 ? void 0 : _f.variations,
            state,
            setState,
            useStateByKey,
        } }, { children: _jsx(Component, Object.assign({}, props)) })));
};
//# sourceMappingURL=RendererContext.js.map